import React from "react";
export var FormContext = React.createContext({});
// export interface FormItemContextValue {
//   /**
//    * 是否禁用
//    * @default false
//    */
//   disabled?: boolean;
// }
// export const FormItemContext = React.createContext<FormItemContextValue>({});
//# sourceMappingURL=FormContext.js.map